import './inventory.scss';
import React, { useEffect, useState } from 'react';
import { InventorySubMenu, MainPages, ProtectionMenuNameOptions } from '@src/utils/enums';
import { useStores } from '../../store';
import Loader from '../../shared/loader/loader';
import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router-dom';
import { convertEnumToDropdownItems, DropdownMenu } from '../../shared/dropdown-menu/dropdown-menu';
import { ExpertViewModal } from '../expert-view-modal/expert-view-modal';
import { EXPERT_VIEW_MODAL_LIBRARY } from '@src/utils/constants';
import { usePageViewEvent } from '../../shared/hooks/use-page-view-event';

export const Inventory: React.FC = observer(() => {
    const { fwVersionStore } = useStores();
    const [showExpertViewModal, setShowExpertViewModal] = useState(false);

    usePageViewEvent(MainPages.POLICY, ProtectionMenuNameOptions.Library);

    useEffect(() => {
        fwVersionStore.setProtectionType(ProtectionMenuNameOptions.Library);
        if (localStorage.getItem(EXPERT_VIEW_MODAL_LIBRARY) !== 'true') {
            setShowExpertViewModal(true);
        }
    }, []);

    return <div className="library" data-testid="library">
        <DropdownMenu items={convertEnumToDropdownItems(InventorySubMenu)} activeSubMenu={fwVersionStore.inventoryType} />
        <div className="page-content" data-testid="page-content">
            {(fwVersionStore.isLoading || !fwVersionStore.selectedFwVersion) && <Loader type="full-screen" />}
            <Outlet />
        </div>
        <ExpertViewModal visible={showExpertViewModal} setVisible={setShowExpertViewModal} component={ProtectionMenuNameOptions.Library} />
    </div>;
});
